function Departments() {
    return (
      <>
        <div className="font-bold text-lg mb-16">Departments</div>
      </>
    );
  }
  
  export default Departments;